import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';

export type SummaryBenefitsCoverageType = {
  title?: string;
  subTitles: { subTitle: string; link: string; target: string }[];
}[];

const SummaryBenefitsCoverageOptions: SummaryBenefitsCoverageType = [
  {
    subTitles: [
      {
        subTitle: '2022 Consumer Choice Medical Plan SBC',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: '2022 Kaiser Medical Plan SBC',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: '2022 EPO Medical Plan SBC',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: '2022 PPO Medical Plan SBC',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
    ],
  },
];

export type SummaryBenefitsCoverageProps = {
  showSummaryBenefitsCoverageModal: boolean;
  handleCloseSummaryBenefitsCoverageModal: () => void;
};

function SummaryBenefitsCoverageModal({
  showSummaryBenefitsCoverageModal,
  handleCloseSummaryBenefitsCoverageModal,
}: SummaryBenefitsCoverageProps) {
  return (
    <>
      <Modal
        className={'p-0'}
        show={showSummaryBenefitsCoverageModal}
        onHide={handleCloseSummaryBenefitsCoverageModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalHeader closeButton={true} leftIcon={light('folder')}>
          <h4 className="text-sm-20-lg-24">Summary of Benefits & Coverage</h4>
        </ModalHeader>
        <Modal.Body>
          <Container className={'p-0'}>
            {SummaryBenefitsCoverageOptions.map(
              ({ title, subTitles }, index) => {
                return (
                  <Row key={index}>
                    <Col>
                      <h6
                        className={
                          'mb-0 pb-4 border-bottom border-info text-primary text-fs-base fw-normal'
                        }
                      >
                        {title}
                      </h6>
                    </Col>
                    <Col className={'col-12 mc-layout-2-col mb-12'}>
                      {subTitles.map(({ subTitle, link, target }, index) => {
                        return (
                          <Row key={index}>
                            <Col>
                              <div
                                className={
                                  'd-flex mb-0 py-6 text-fs-6 border-bottom border-info fw-light'
                                }
                                key={index}
                              >
                                {subTitle}
                                <a
                                  className={'text-decoration-none ms-auto'}
                                  href={link}
                                  target={target}
                                >
                                  <FontAwesomeIcon icon={light('file-pdf')} />
                                  <span className={'ms-5'}>PDF</span>
                                </a>
                              </div>
                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                  </Row>
                );
              }
            )}
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            onMouseDown={handleCloseSummaryBenefitsCoverageModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SummaryBenefitsCoverageModal;
